import { createFileRoute, useNavigate } from "@tanstack/react-router"
import { useTypedFlag } from "@/features/feature-flags/registry"
import { FixtureDetectionValidationPage } from "@/features/fixture-detection-validation/components/FixtureDetectionValidationPage"
import { getFixtureValidationResults } from "@/features/fixture-detection-validation/server/fixtureValidationResults"
import { fixtureValidationQuerySchema } from "@/features/fixture-detection-validation/types/fixtureValidationTypes"
import { useFilters } from "@/hooks/useFilters"
import { fixtureValidationQueryKeys } from "@/lib/queryKeys"

export const Route = createFileRoute("/(authenticated)/settings/fixture-detection-validation/")({
  validateSearch: fixtureValidationQuerySchema,
  loaderDeps: ({ search }) => search,
  loader: ({ context, deps }) => {
    void context.queryClient.ensureQueryData({
      queryKey: fixtureValidationQueryKeys.list(deps),
      queryFn: () => getFixtureValidationResults({ data: deps }),
    })
  },
  component: FixtureDetectionValidationRoute,
})

function FixtureDetectionValidationRoute() {
  const navigate = useNavigate({ from: Route.fullPath })
  const { value: enabled, isLoading } = useTypedFlag("fixture-detection-validation")
  const { filters, setFilters, resetFilters } = useFilters(Route.id)

  if (!isLoading && !enabled) {
    void navigate({ to: "/settings" })
    return null
  }

  return (
    <FixtureDetectionValidationPage
      filters={filters}
      setFilters={setFilters}
      resetFilters={resetFilters}
    />
  )
}
